module.exports = __webpack_public_path__ + "static/media/RollWithItINTACRJPartyLightsA0007_bg_clean_v001.c6b68ac6.webp";